// extracted by mini-css-extract-plugin
export var root = "G_vj";
export var wrapper = "G_vk";
export var image = "G_vl d_w d_y d_W";
export var imageWithHeight = "G_vm";
export var crop = "G_vn";
export var round = "G_vp";
export var fixedHeight = "G_vq";